import React from "react";
import { connect } from 'react-redux';
import SweetAlert from "react-bootstrap-sweetalert";
import ReactTable from "react-table";
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// material-ui icons
import Close from "@material-ui/icons/Close";
import Add from "@material-ui/icons/AddBox";
import People from "@material-ui/icons/People";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { fetchProjectsRequest, suspendProjectRequest, SuspendProjectReset } from "../../../actions/project";

const successButtonStyle = {backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}

      const dangerButtonStyle = {backgroundColor: "red", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}


class ViewProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null
    };
  }

  componentWillMount() {
    this.props.dispatch(fetchProjectsRequest());
  }
 
  suspendProject(project){
    console.log("Are you sure you want to suspend project: ", project.name);
    this.props.dispatch(suspendProjectRequest(project._id))
    this.hideAlert()
  }
  suspendWarningAlert(project) {
    const projectName = project.name
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.suspendProject(project)}
          onCancel={() => this.cancelSuspendAlert()}
          confirmBtnStyle={successButtonStyle}
          cancelBtnStyle={dangerButtonStyle}
          confirmBtnText="Yes, suspend it!"
          cancelBtnText="Cancel"
          showCancel
        >
          <p style={{fontSize:"20px"}}>You want to suspend {projectName}!</p>
        </SweetAlert>
      )
    });
  }
  
  cancelSuspendAlert() {
    this.setState({
      alert: (
        <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="Cancelled"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnStyle={successButtonStyle}
        >
        </SweetAlert>
      )
    });
  }
  
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  
  displayErrorFeedback() {
    const e = this.errorMessage()
    return <SweetAlert
      danger
      style={{ display: "block", marginTop: "-100px" }}
      title="Cancelled"
      onConfirm={() => this.reset()}
      onCancel={() => this.reset()}
      confirmBtnStyle={dangerButtonStyle}
    >
      <div>
        {e.map((item, index) => {
  
          return <div key={index}> {item}</div>
        })}
      </div>
    </SweetAlert>
  }
  
  displaySuccessFeedback() {
    return <SweetAlert
    success
    style={{ display: "block", marginTop: "-100px" }}
    title="Suspended!"
    onConfirm={() => this.reset()}
    confirmBtnStyle={successButtonStyle}
  >
    Project has been supspended.
  </SweetAlert>
  }
  
  
  displayLoader() {
    return <Dialog
      open={true}
      onClose={this.hideAlert}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  }
  
  errorMessage() {
    let e = this.props.projectData.suspendProjectErrors
    if (Array.isArray(e)) {
      let i;
      let el = []
      for (i = 0; i < e.length; i++) {
        let obj = e[i].constraints
        for (var property in obj) {
          el.push(obj[property] + '; ')
        }
      }
      return el
  
    }
    else if (e.message) {
      return [e.message]
    } else {
      return ["unexpected Error occured"]
    }
  }
  
  reset() {
    this.props.dispatch(SuspendProjectReset())
  }
  render() {
    const { classes } = this.props;
  

    let  projects = this.props.projectData.projects || [];

     

    console.log('projects', projects);

    return (
      <GridContainer>
        <div>
          <div style={{ textAlign: "center" }}>
            {this.props.projectData.suspendProjectErrors ? (this.displayErrorFeedback()) : ('')}
            {this.props.projectData.suspendProjectSuccess ? (this.displaySuccessFeedback()) : ('')}
            {this.props.projectData.suspendProjectLoader ? (this.displayLoader()) : ('')}
            {this.props.projectData.loader ? (this.displayLoader()) : ('')}

          </div>
        </div>
      {this.state.alert}

        <GridItem xs={12}>
        <center>
          <Button color="info" onClick={() => this.props.history.push('/admin/project')}>
            <Add />
            Register Project
          </Button>
          </center>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="info">
                <People />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>List of available projects</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={projects.map((project, key) => {
                  return {
                    id: key,
                    name: project.name,
                    createdAt: project.createdAt,
                    status: project.status,
                    remarks: project.remarks,
                    actions: (
                      <div className="actions-right">
                        <Tooltip title="Suspend project" placement="top-start">
                        <Button
                          justIcon
                          round
                          simple
                          onClick={this.suspendWarningAlert.bind(this, project)}
                          color="danger"
                          className="remove"
                        >
                          <Close />
                        </Button>
                        </Tooltip>

                      </div>
                    )
                  };
                })
              }
                filterable
                columns={[
                  {
                    Header: "Project Name",
                    accessor: "name"
                  },
                  {
                    Header: "Created Date",
                    accessor: "createdAt"
                  },
                  {
                    Header: "Status",
                    accessor: "status"
                  },
                  {
                    Header: "Remarks",
                    accessor: "remarks"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={30}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(extendedTablesStyle)(
  connect(state => ({
    projectData: state.projectState,
  }))(ViewProjects)
);
